import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'stringTransform', standalone: false})
export class FormatStringPipe implements PipeTransform {
	transform(value: string): boolean {
		if (value.split(" ").length <= 2) {
			return true;
		} else if (value.split(" ").length <= 3 && value.split(" ")[2].length === 1) {
			return true;
		} else {
			return false;
		}
	}
}
